<script setup lang="ts">
import { useGlobalState } from '../../composables/useGlobalState'
import { useDialogMessage } from '../../messages/useDialogMessage'

const { dialog } = useGlobalState()
const messages = useDialogMessage('area')

function areaPointerdown(areaId: string) {
  const dialogIdTh = areaId.replace('area', 'location') + '-th'
  const dialogIdEn = areaId.replace('area', 'location') + '-en'

  if (!(dialog.value[dialogIdTh] || dialog.value[dialogIdEn])) {
    console.log('MapArea click: OpenDialogCommand ' + dialogIdTh)
    messages.OpenDialogCommand(dialogIdTh)
  }

  if (areaId == 'area2') {
    areaPointerdown('area6')
  }
}
</script>

<template>
  <img class="watmap-bg" src="/images/map-bg.jpg" usemap="#watmap" />
  <map name="watmap">
    <area shape="rect" coords="1176,525,1548,804" @pointerdown="areaPointerdown('area1')" />
    <area shape="rect" coords="1843,698,2177,1471" @pointerdown="areaPointerdown('area2')" />
    <area shape="rect" coords="3059,770,3124, 831" @pointerdown="areaPointerdown('area3')" />
    <area shape="rect" coords="2483,866,3037,1295" @pointerdown="areaPointerdown('area4')" />
    <area
      shape="poly"
      coords="2237,1548,2885,1548,2885,1522,3094,1522,3094,1631,2885,1631,2885,1583,2645,1583,2645,1641,2237,1641"
      @pointerdown="areaPointerdown('area5')"
    />
    <area
      shape="poly"
      coords="1251,1169,1415,1169,1415,1099,1618,1099,1618,1340,1415,1340,1415,1270,1251,1270"
      @pointerdown="areaPointerdown('area7')"
    />
  </map>
</template>

<style scoped>
.watmap-bg {
  position: absolute;
  left: 0;
  top: 0;
}
area {
  cursor: pointer;
}
</style>
